import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import { Box } from "theme-ui";
import { Column, HeadingRegularVariants, TextVariants, LinkVariants, StandardXAxisPadding, FontWeight } from "../../index";
export const TextAndLinksBanner = ({ title, text, links = [] }) => {
    if (!title && !text && !links.length)
        return null;
    return (_jsx(Box, { sx: {
            width: "100%",
            height: "100%",
            backgroundColor: "blue.2",
            display: "flex",
            alignItems: "center",
            py: [24, null, null, 48],
            color: "white",
            px: StandardXAxisPadding
        }, children: _jsxs(Column, { children: [_jsx(Box, { as: "h6", marginBottom: ["8px", null, null, text ? "8px" : "16px"], sx: {
                        variant: `text.${HeadingRegularVariants.sixth}`,
                        fontWeight: FontWeight.textBold
                    }, children: title }), _jsx(Box, { marginBottom: ["8px", null, null, "16px"], children: _jsx("p", { sx: {
                            variant: TextVariants.editorialParagraphLarge
                        }, children: text }) }), links.length > 0 && (_jsx(Box, { children: links.map((link, i) => (_jsxs(Box, { sx: { display: "inline-block" }, children: [_jsx("a", { href: link.href, sx: {
                                    variant: `links.${LinkVariants.card}`
                                }, children: link.title }), i !== links.length - 1 && (_jsx("span", { sx: {
                                    display: "inline-block",
                                    ml: 8,
                                    mr: 8
                                }, children: "\u2022" }))] }, `related-content-link-${i}`))) }))] }) }));
};
//# sourceMappingURL=TextAndLinksBanner.js.map